import React from "react";
import './about.css';

function About() {
    return (
        <div className="about-text">
            <p>I began my professional journey as a translator, driven by a deep appreciation for language and the way it shapes the world around us. I speak German fluently and am conversational in Arabic and Icelandic, with the majority of my translation experience focused on German.</p>
            <p>After several years in translation, I set out to pursue a new challenge and discovered a passion for web development. Since then, I've immersed myself fully in building modern, responsive, and scalable applications. I work with technologies such as JavaScript, HTML, CSS, React, Vite, and both SQL and NoSQL databases, along with tools and frameworks including Node.js, Express, REST APIs, Git/GitHub, Tailwind CSS, responsive design principles, deployment workflows, and performance optimization.</p>
            <p>Web development is an ever-evolving field that demands continuous learning, adaptability, and attention to detail—qualities I bring to every project I take on. Whether you need a new website, a custom web application, or improvements to an existing platform, I'm always open to discussing new opportunities.</p>

            <p>If you have a project in mind, feel free to reach out for more information.</p>

            <div className="signature">— Geist</div>
        </div>
    )
}

export default About;